export const FALLBACK_FLAG = "🏳️";

export function flagEmoji(countryCode: string | null | undefined): string {
  if (!countryCode || !/^[a-zA-Z]{2}$/.test(countryCode)) return FALLBACK_FLAG;
  const A = 127397;
  return String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map((c) => c.charCodeAt(0) + A),
  );
}

export function isValidHandle(handle: string): boolean {
  return /^[a-z0-9_]{2,16}$/i.test(handle);
}

export function normalizeHandle(handle: string): string {
  return handle.trim().toLowerCase();
}
